<template>
	<div class="tpl home-wrap" :class="{'light':isLight==1,'dark':isLight==0}">
		<div class="page-header">
			<p class="title">今日运势</p>
		</div>
		<div class="img-box">
			<img v-if="isLight==1" src="@/assets/img/home/bg-bai.png" alt="" />
			<img v-else src="@/assets/img/home/bg-wan.png" alt="" />
			<span class="day">{{fateList.weekday}}</span>
			<!--<button class="download-btn">下载鱼水缘App</button>-->
		</div>
		<div class="text-box">
			<ul>
				<li>
					<span class="name">忌</span>
					<span class="value">{{fateList.ji}}</span>
				</li>
				<li>
					<span class="name">宜</span>
					<span class="value">{{fateList.suit}}</span>
				</li>
				<li>
					<span class="name">五行</span>
					<span class="value">{{fateList.wuxing}}</span>
				</li>
				<li>
					<span class="name">冲煞</span>
					<span class="value">{{fateList.chong}}</span>
				</li>
				<li>
					<span class="name">拜祭</span>
					<span class="value">{{fateList.baiji}}</span>
				</li>
			</ul>
		</div>
		<div class="activity-box">
			<div class="activity-item">
				<div class="img-box">
					<img src="@/assets/img/home/order-fate.jpg" alt="">
					<span class="tip">预约</span>
				</div>
				<div class="item-text">
					<p class="item-title">预约大师解锁更多</p>
					<p class="item-content">谁都想知道自己一生中的事业财运、婚姻、健康、性格谁都想知道自己一生中的事业财运、婚姻、健康、性格</p>
					<p class="item-btn"><button @click="orderFortune">立即预约</button></p>
				</div>
			</div>
		</div>
		<div class="download-btn"><a href="http://www.yushuiyuan.cn/download.html" target="_blank"><button>下载鱼水缘App</button></a></div>
		
		<get-position @getPosition="getPosition"></get-position>
	</div>
</template>

<script>
	import GetPosition from '../Common/GetPosition'
	export default {
		name: "home",
		components:{
			GetPosition
		},
		data() {
			return {
				uid: "",
			  	fateList:"",
			}
		},
		computed:{
		  	isLight(){
		  		var h = new Date().getHours();
		  		if(h>=6&&h<=18){
		  			return 1;
		  		}else{
		  			return 0;
		  		}
		  	}
		},
		created() {
			this.uid = this.$store.state.UserId; //获取当前用户的id
			this.$store.commit("changeTabChoosed", "home");
			this.$store.commit("changeTabBarShow", true);
			
			this.getBaseInfo();
		},
		mounted() {
			var _this = this;
			
		},
		methods: {
			getPosition(data){
				console.log(data);
				this.$store.commit("setNowAdd", data.name);
				
			},
			getBaseInfo(){
				this.$axios.get("HomePage/Fortune").then(res=>{
					console.log(res);
	  				if(res.data.code==200){
	  					this.fateList = res.data.data;
	  				}
				}).catch(err=>{
					console.log(err)
				})
		  	},
		  	orderFortune(){
		  		console.log(this.uid==""||this.uid==null)
		  		if(this.uid==""||this.uid==null){
		  			this.$toast({
						message:"请登录后尝试~",
						position:"bottom",
						duration:3000
					});
		  			return false;
		  		}else{
		  			this.$router.push({
		  				name:'order-fortune'
		  			})
		  		}
		  		
		  	},
		}
	}
</script>

<style scoped>
	.home-wrap{background:#f4f4f4;}
	.page-header{width:100%;height:2.5rem;position:fixed;top:0;left:0;z-index:9;}
	.page-header .title{text-align:center;color:#fff;font-weight:bold;font-size:1rem;line-height:2.5rem;}
	.page-header .back{width:2.5rem;height:2.5rem;position:absolute;top:0;left:0;display:flex;justify-content:center;align-items:center;}
	.page-header .back img{width:1.8rem;}
	.img-box{position:relative;}
	.img-box img{width:100%;display:block;}
	.img-box .day{position:absolute;top:3rem;right:0;padding:0.5rem 0.5rem 0.5rem 1rem;border-radius:2rem 0 0 2rem;font-size:1rem;font-weight:bold;}
	
	.light .img-box .day{color:#01AEF0;background:rgba(255,255,255,.7);}
	.dark .img-box .day{color:#01AEF0;background:rgba(4,38,70,.7);}
	.text-box{background:#f4f4f4;border-radius:1rem 1rem 0 0;padding:1rem;margin-top:-0.7rem;position:relative;}
	.text-box li{display:flex;justify-content:flex-start;align-items:center;background:#fff;border-bottom:1px solid #f4f4f4;padding:0.5rem 0;}
	.text-box li .name{font-size:0.95rem;color:#282828;font-weight:bold;padding:0 1rem;white-space:nowrap;}
	.text-box li .value{font-size:0.95rem;color:#7b7b7b;padding-right:0.5rem;}
	.activity-box{padding:0 1rem;background:#f4f4f4;}
	.activity-item{display:flex;justify-content:flex-start;align-items:center;background:#fff;margin-bottom:1rem;}
	.activity-item .img-box{flex:5;position:relative;}
	.activity-item .item-text{flex:6;}
	.activity-item .img-box .tip{position:absolute;top:0.5rem;right:0.5rem;background:rgba(255,97,97,.9);color:#fff;font-size:0.65rem;display:block;padding:2px 8px;border-radius:0.5rem;}
	.activity-item .item-text{padding:0.5rem;}
	.activity-item .item-text .item-title{font-size:0.9rem;color:#282828;line-height:1.5rem;font-weight:bold;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;overflow:hidden;}
	.activity-item .item-text .item-content{font-size:0.8rem;color:#7b7b7b;line-height:1.2rem;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;}
	.activity-item .item-btn{text-align:right;padding:0.5rem 0 0;}
	.activity-item .item-btn button{background:#ff6161;color:#fff;border:0;outline:0;font-size:0.8rem;padding:4px 8px;border-radius:4px;}
	.download-btn{
		padding:0 2rem 1rem;
	}
	.download-btn a{
		display: inline-block;
		display: flex;
		justify-content: center;
		align-items: center;
		text-decoration: none;
	}
	.download-btn button{
		width: 60%;
		height: 2.5rem;
		border: 1px solid rgba(84, 21, 249, .6);
		border-radius: 2rem;
		background: none;
		outline: 0;
		color: #5415f9;
		transition: 300ms;
		background: rgba(84,21,249,.2);
	}
	.download-btn button:active{
		background: rgba(84,21,249,1);
		color: #fff;
	}
</style>


// WEBPACK FOOTER //
// src/components/Home/Home.vue